import { createUseStyles } from 'react-jss';

export const useStyles = createUseStyles({
    errorMessageClass: {},
    validatedInputWrapper: {
        maxWidth: '560px',
        margin: '0 auto',
    }
});
